import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Guía Pastoral</h3>
            <p>Mentoría pastoral personalizada para líderes cristianos experimentados.</p>
          </div>

          <div className="footer-section">
            <h4>Enlaces Rápidos</h4>
            <ul>
              <li><a href="#inicio">Inicio</a></li>
              <li><a href="#acerca">Acerca</a></li>
              <li><a href="#recursos">Recursos</a></li>
              <li><a href="#contacto">Contacto</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Recursos</h4>
            <ul>
              <li><a href="#recursos">Artículos</a></li>
              <li><a href="#recursos">Videos</a></li>
              <li><a href="#contacto">Consulta</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contacto</h4>
            <p>¿Listo para dar el siguiente paso en tu ministerio?</p>
            <a href="#contacto" className="footer-cta">Agendar Consulta</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 Mentoría con Dr. Moisés Mejía . Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;